import {
  BarChart3,
  FileText,
  Image,
  Layers,
  Palette,
  Sparkles,
  Target,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react';

export type ProFeatureId =
  | 'forecast'
  | 'netWorth'
  | 'unlimitedRules'
  | 'unlimitedGoals'
  | 'advancedInsights'
  | 'pdfReports'
  | 'premiumThemes'
  | 'sharedBudgets'
  | 'aiAssistant'
  | 'unlimitedReceipts';

export interface ProFeature {
  id: ProFeatureId;
  title: string;
  oneLiner: string;
  icon: LucideIcon;
  comingSoon?: boolean;
}

export const PRO_FEATURES: Record<ProFeatureId, ProFeature> = {
  forecast: {
    id: 'forecast',
    title: 'Cash Flow Forecast',
    oneLiner: 'See your balance 30 days ahead.',
    icon: TrendingUp,
  },
  netWorth: {
    id: 'netWorth',
    title: 'Net Worth Tracking',
    oneLiner: 'Watch your total wealth move over time.',
    icon: BarChart3,
  },
  unlimitedRules: {
    id: 'unlimitedRules',
    title: 'Unlimited Rules',
    oneLiner: 'Beyond 5 categorization rules.',
    icon: Layers,
  },
  unlimitedGoals: {
    id: 'unlimitedGoals',
    title: 'Unlimited Goals',
    oneLiner: 'Beyond 3 savings goals.',
    icon: Target,
  },
  advancedInsights: {
    id: 'advancedInsights',
    title: 'Advanced Insights',
    oneLiner: '6-month trends, custom ranges, year-over-year.',
    icon: Sparkles,
  },
  pdfReports: {
    id: 'pdfReports',
    title: 'PDF Reports',
    oneLiner: 'Export period summaries with KPIs and tables.',
    icon: FileText,
  },
  premiumThemes: {
    id: 'premiumThemes',
    title: 'Premium Themes',
    oneLiner: 'Obsidian, Sunset, Forest, Aurora.',
    icon: Palette,
  },
  sharedBudgets: {
    id: 'sharedBudgets',
    title: 'Shared Budgets',
    oneLiner: 'Track money with a partner.',
    icon: Users,
    comingSoon: true,
  },
  aiAssistant: {
    id: 'aiAssistant',
    title: 'AI Assistant',
    oneLiner: 'Ask Margin anything about your money.',
    icon: Sparkles,
    comingSoon: true,
  },
  unlimitedReceipts: {
    id: 'unlimitedReceipts',
    title: 'Unlimited Receipts',
    oneLiner: 'Beyond 20 attached photos.',
    icon: Image,
  },
};

export const FREE_LIMITS = {
  rules: 5,
  goals: 3,
  receipts: 20,
} as const;
